import React from 'react';

const UniversityTeacherInfo: React.FC = () => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.874 14.0117H20.5122C21.3942 14.0117 23.2905 14.3425 23.8197 15.6655L26.4657 22.2804C26.6862 22.9419 26.9287 24.4633 26.1349 25.2571C26.0247 25.4776 25.3412 25.9186 23.489 25.9186H20.843C20.3598 25.8241 19.3827 25.2997 19.3399 23.9578C19.2971 22.6159 20.3241 22.2804 20.843 22.2804H22.123V16.8662L17.3061 18.8197V25.9186H16.4765V18.8197L11.6065 16.8662V22.2804H12.7312C13.3021 22.293 14.4438 22.6781 14.4438 24.1184C14.4438 25.5586 13.3021 25.9186 12.7312 25.9186H9.33256C8.85978 25.8448 7.79647 25.4992 7.32549 24.7071C6.8545 23.915 7.12924 22.7593 7.32549 22.2804L9.7623 15.9028C10.0299 15.2725 11.0468 14.0117 12.9736 14.0117H16.874Z"
      fill="currentColor"
    />
    <ellipse cx="16.8764" cy="9.69425" rx="3.61271" ry="3.61271" fill="currentColor" />
  </svg>
);

export default UniversityTeacherInfo;
